import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("cc_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export const imgSrc = (path) =>
    path && path.startsWith("http") ? path : `${BACKEND_URL}${path}`;

export const buildWaLink = (number, ref) => {
    const message = `Olá! Tenho interesse neste produto do catálogo da Campo & Concreto${
        ref ? ` (ref: ${ref})` : ""
    }. Poderia me passar o valor, os tamanhos disponíveis e o prazo de entrega?`;
    return `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
};

export const SUBS = [
    ["brasileirao", "BRASILEIRÃO"],
    ["bundesliga", "BUNDESLIGA"],
    ["premier-league", "PREMIER LEAGUE"],
    ["portugues", "CAMPEONATO PORTUGUÊS"],
    ["italiano", "CAMPEONATO ITALIANO"],
    ["ligue-1", "LIGUE 1"],
    ["la-liga", "LA LIGA"],
    ["selecoes", "SELEÇÕES"],
];
